export const isProd = true//process.env.NODE_ENV === 'production'


export const MEDIA_URL = isProd ? "https://nest.falconcloak.in" :  "http://localhost:9020"
// export const MEDIA_URL = "https://falconcloak-backend.herokuapp.com"

export const API_URL = `${MEDIA_URL}/api/`
